/**
 * Recupera a mensagem de erro retornada pela API
 * @param error erro da requisição
 */
export function getApiErrorMessage(error: any): string | undefined {
  const data = error?.response?.data;
  const message = data?.error?.errorMessage ?? data?.message;

  return typeof message === 'string' ? message : undefined;
}
